module.exports = __webpack_public_path__ + "img/step3.c11f2310.svg";